function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6283 4.22324H15.1752L11.7988 0.828125V3.3877C11.7988 3.84666 12.1727 4.22324 12.6283 4.22324Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.6652V18.3348C0 19.2527 0.736035 20 1.65316 20H14.3468C15.2581 20 16 19.2468 16 18.3348V5.89585H12.6236C11.2567 5.89585 10.1409 4.77199 10.1409 3.39512V0H1.65316C0.736035 0 0 0.741394 0 1.6652ZM2.44177 14.5925C2.44177 14.1336 2.81563 13.757 3.27127 13.757H12.7287C13.1844 13.757 13.5582 14.1336 13.5582 14.5925C13.5582 15.0515 13.1844 15.4281 12.7287 15.4281H3.27127C2.81563 15.4281 2.44177 15.0515 2.44177 14.5925ZM2.44177 10.1559C2.44177 9.69697 2.81563 9.32039 3.27127 9.32039H12.7287C13.1844 9.32039 13.5582 9.69697 13.5582 10.1559C13.5582 10.6149 13.1844 10.9915 12.7287 10.9915H3.27127C2.81563 10.9915 2.44177 10.6149 2.44177 10.1559Z"
});

function SvgIconInsuranceCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsuranceCompare);
export default __webpack_public_path__ + "static/media/icon-insurance-compare.8424dcd7.svg";
export { ForwardRef as ReactComponent };